module.exports = __webpack_public_path__ + "img/background-53.821cf7ca.png";